export var getCountry = `query getCountry($OperationList: [OperationList]) {
  getCountry(OperationList: $OperationList) {  
        Name
        CountryCode
        IsActive
        IsDefault
        Nationality
        ISOCode
        LanguageGuid
        GroupGuid
        CountryGuid
}
}`;